import styled from 'styled-components';

export const AlbumDetailStyle = styled.div`

    min-width:1200px; 
    width:100%;

    background:#C9F2FF;
    
    @media screen and (max-width: 1200px) {
        
        .wrapper{
            width:80%!important;
        }

    }


    .albumdetail{
        display:flex;
        flex-direction:column;
        align-items:center;
        overflow:hidden;
        
        background:#C9F2FF;

        .home-header{
            /* width:1920px; */
            width:100%;
            height:94px;

            background:url(${require('images/home/top.png')}) no-repeat center top;
            background-size:cover;

            .wrapper{
                display:flex;
                justify-content:space-between;
                align-items:center;

                margin:0 auto;
                width:1000px;
                height:94px;

                .home-logo{
                    margin-left:18px;
                    width:197px;
                    height:66px;

                    cursor: pointer;
                }

                .home-header-right{
                    display:flex;
                    align-items:center;

                    .entry{
                        font-size:16px;
                        font-family:SourceHanSansCN-Bold,SourceHanSansCN;
                        font-weight:bold;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }

                    .down{
                        display:flex;
                        justify-content:center;
                        align-items:center;

                        width:111px;
                        height:39px;
                        margin-left:82px;
                        margin-right:31px;

                        background:rgba(255,255,255,1);
                        box-shadow:0px 2px 5px 0px rgba(118,199,236,1);
                        border-radius:20px;
                        font-size:18px;
                        font-family:SourceHanSansCN-Medium,SourceHanSansCN;
                        font-weight:500;
                        color:rgba(115,209,254,1);
                        cursor: pointer;
                    }
                }
            }
        }

        .home-footer{
            display:flex;
            flex-direction:column;
            align-items:center;

            /* width:1920px; */
            width:100%;
            height:632px;
            padding-top:380px;
            margin-top:-200px;

            background:url(${require('images/home/bottom.png')}) no-repeat center bottom;
            background-size:cover;

            .footer-top{
                display:flex;
                align-items:center;
                
                .word1{
                    width:273px;
                    /* height:101px; */

                    font-size:14px;
                    font-family:SourceHanSansCN-Medium,SourceHanSansCN;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:25px;
                }

                .word2{
                    margin:0 139px 0 97px;
                    width:194px;
                    height:101px;

                    font-size:14px;
                    font-family:SourceHanSansCN-Medium,SourceHanSansCN;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:25px;
                }

                .footer-i{
                    display:flex;
                    flex-direction:column;
                    align-items:center;

                    >img{
                        width:94px;
                        height:94px;
                        background:rgba(255,255,255,1);
                    }

                    .text{
                        margin-top:10px;
                        /* width:54px;
                        height:14px; */

                        font-size:14px;
                        font-family:SourceHanSansCN-Normal,SourceHanSansCN;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        line-height:21px;
                    }
                }

            }

            .footer-bottom{
                display:flex;
                align-items:center;
                justify-content:center;

                .foot-tip{
                    font-size:14px;
                    font-family:SourceHanSansCN-Normal,SourceHanSansCN;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                }
            }
        }

        .detail-main{
            display:flex;
            flex-direction:column;

            margin-top:17px;
            width:1000px;
            height:1282px;

            background:rgba(255,255,255,1);
            border-radius:25px;

            .album{
                display:flex;

                padding:53px 62px 46px 45px;

                .album-cover{
                    width:200px;
                    height:200px;
                    margin-right:34px;

                    box-shadow:0px 2px 8px 0px rgba(166, 165, 165,.27);
                    border-radius:10px;
                }

                .album-right{
                    display:flex;
                    flex-direction:column;

                    .album-title{
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space:nowrap;

                        width:659px;
                        margin:16px 0 15px;

                        font-size:29px;
                        font-family:PingFangSC-Medium,PingFang SC;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                        line-height:41px;
                    }

                    .album-intro{
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space:nowrap;

                        width:659px;

                        font-size:16px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        line-height:22px;
                    }

                    .album-con{
                        display:flex;

                        margin:61px 0 0;

                        font-size:16px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(51,51,51,1);
                        line-height:22px;

                        .num{
                            margin-right:29px;
                        }

                        .view{

                        }
                    }
                }
            }

            .pro-list{
                display:flex;
                flex-direction:column;
                overflow-y:auto;
                overflow-x:hidden;

                width:100%;
                height:924px;

                .pro-item{
                    flex-shrink:0;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;

                    padding:0 62px 0 47px;
                    width:100%;
                    height:132px;

                    background:rgba(252,253,255,1);
                    border:1px solid rgba(240,240,241,1);

                    .pro{
                        display:flex;


                        .pro-cover{
                            margin-right:15px;
                            width:80px;
                            height:80px;

                            box-shadow:0px 2px 8px 0px rgba(166, 165, 165,.27);
                            border-radius:10px;
                            cursor: pointer;
                        }

                        .pro-con{
                            display:flex;
                            flex-direction:column;
                            justify-content:space-between;

                            .title{
                                /* width:126px; */
                                height:25px;
                                font-size:18px;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(51,51,51,1);
                                line-height:25px;
                                cursor: pointer;
                            }

                            .time{
                                display:flex;
                                align-items:center;

                                .text{
                                    /* width:56px; */
                                    height:20px;
                                    margin-left:10px;

                                    font-size:14px;
                                    font-family:PingFangSC-Regular,PingFang SC;
                                    font-weight:400;
                                    color:rgba(154,156,155,1);
                                    line-height:20px;
                                }
                            }
                        }
                    }

                    .play{
                        display:flex;
                        justify-content:center;
                        align-items:center;

                        width:110px;
                        height:39px;

                        background:rgba(40,182,255,1);
                        box-shadow:0px 2px 4px 0px rgba(40,182,255,0.42);
                        border-radius:20px;
                        font-size:16px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }

                    .play:hover{
                        background:#00A3F7;
                    }
                }
            }

        }
    }

    .mask{
        position: fixed;
        top:0;
        left:0;
        z-index:12;

        width:100%;
        height:100%;

        .mask-dg{
            width:100%;
            height:100%;
        }

        .mask-con{
            position: absolute;
            top:200px;
            left:0;
            right:0;
            margin:0 auto;
            z-index:100;
            display:flex;
            flex-direction:column;
            align-items:center;

            width:350px;
            height:353px;

            background:rgba(255,255,255,1);
            box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);
            border-radius:14px;

            .icon{
                margin-top:-108px;
                width:123px;
                height:125px;
            }

            .title{
                /* margin:12px 0 18px; */

                font-size:20px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(51,51,51,1);
            }

            .down{
                margin:20px 0 16px;
                width:250px;
                height:250px;
                
                background:rgba(216,216,216,1);
                border-radius:13px;
            }

            .close{
                position: absolute;
                top:13px;
                right:13px;

                width:16px;
                height:16px;
                cursor: pointer;
            }
        }
    }

`;